import { memo, useEffect, useState } from "react";
import ToastContainer from "react-bootstrap/ToastContainer";
import Toast from "react-bootstrap/Toast";
import { FaExclamationTriangle } from "react-icons/fa";
import { FaCheckCircle } from "react-icons/fa";
import { useTranslation } from "react-i18next";

const ToastNetworkStatus = ({ isOnline, delayTime }) => {
  const [show, setShow] = useState(false);
  const [toastTime, setToastTime] = useState("Now"); // The time when toast happens
  const { t } = useTranslation();

  // Here trigger show a toast when the network status change
  useEffect(() => {
    setShow(true);
    setToastTime(new Date().toLocaleTimeString());
  }, [isOnline]);

  // Here hide the toast at startup
  useEffect(() => {
    setShow(false);
  }, []);

  return (
    <ToastContainer position={"middle-center"}>
      <Toast onClose={() => setShow(false)} show={show} delay={delayTime} autohide bg={isOnline ? "success" : "danger"}>
        <Toast.Header>
          {isOnline ? <FaCheckCircle className="me-2 text-success" /> : <FaExclamationTriangle className="me-2 text-danger" />}
          <strong className="me-auto">{t("networkStatus")}</strong>
          <small>Time( {toastTime} )</small>
        </Toast.Header>

        <Toast.Body>
          {isOnline ? <h3 className="text-center">{t("youAreOnline")}</h3> : <h3 className="text-center">{t("youAreOffline")}</h3>}
        </Toast.Body>
      </Toast>
    </ToastContainer>
  );
};

export default memo(ToastNetworkStatus);
